<script lang="ts">
	import { CollapsibleSectionNoBind, LoadingSpinner } from "misc-ui"
	import { getContext } from "svelte"
	import { SidebarController } from "./SidebarController.svelte"
	import { Responsive } from "responsive"
	import { ImageModifierController } from "../ImageModifierController.svelte"

	let expandHelp = $derived(SidebarController.showDetails)
	let controller = getContext<ImageModifierController>("controller")

	let hasRemoved = $derived(controller.isRemoved)
	let isLoading = $state(false)

	function onVerify() {
		isLoading = true
		controller.approveRemoval()
	}

	function onDeny() {
		controller.denyRemoval()
	}
</script>

<CollapsibleSectionNoBind expanded={expandHelp} onclick={SidebarController.toggleDetails}>
	{#snippet header()}
		<div class="heading">
			<h3>Remove background</h3>
			<button class="info-heading link-button small">{expandHelp ? "Hide" : "More"} details</button>
		</div>
	{/snippet}
	{#snippet content()}
		<p>
			<strong
				>{Responsive.isMobile ? "Tap" : "Click"} on the section you want to project onto.</strong
			>
		</p>
	{/snippet}
</CollapsibleSectionNoBind>
<hr />
{#if hasRemoved}
	<p class="verify">Is the background hidden?</p>
	<div class="button-container" id="verify-buttons">
		{#if isLoading}
			<LoadingSpinner height="2rem" color="var(--color-main)" />
		{:else}
			<button class="outline-button sidebar-button warn" onclick={onDeny}>No</button>
			<button class="outline-button sidebar-button" onclick={onVerify}>Yes</button>
		{/if}
	</div>
{:else}
	<div class="button-container">
		<button
			class="outline-button sidebar-button warn"
			onclick={() => SidebarController.setView("default")}>← Go Back</button
		>
	</div>
{/if}

<style>
	p {
		color: var(--color-text);
		line-height: 1.2em;
	}

	.verify {
		color: var(--color-text-light);
		margin-top: auto;
		text-align: center;
	}

	:global(#snapshot-modify-sidebar) #verify-buttons.button-container {
		margin-top: 0;
	}
</style>
